export default __webpack_public_path__ + "fc5bab8e0aedd34e1d3ed59233b7e6bc.svg";